module.exports = anime;